import { Button } from '@repo/shadcn';

import { IwForm } from '../../../form';
import { TextField } from '../../../form/fields';
import BtnLoader from '../../../ui/loader/btn-loader';
import { CreateTypeSchema, CreateTypeSchemaType } from './type.schema';

type TypeFormProps = {
    isLoading: boolean;
    onSubmit: (data: CreateTypeSchemaType) => void;
    initialValues: CreateTypeSchemaType;
};

export const TypeForm = ({
    isLoading,
    onSubmit,
    initialValues,
}: TypeFormProps) => {
    return (
        <IwForm
            schema={CreateTypeSchema}
            logErrors
            onSubmit={(data) => {
                onSubmit(data as CreateTypeSchemaType);
            }}
            initialValues={initialValues}
        >
            <div className="space-y-4">
                <TextField<CreateTypeSchemaType>
                    name="name"
                    label="Name"
                    placeholder="Enter name"
                />

                <div className="flex justify-end">
                    <Button type="submit" disabled={isLoading}>
                        {isLoading ? <BtnLoader /> : 'Create'}
                    </Button>
                </div>
            </div>
        </IwForm>
    );
};
